document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.querySelector('.niccos-reviews__wrapper');
  const bullets = document.querySelectorAll('.niccos-reviews__bullet');
  const reviewItems = document.querySelectorAll('.review-item');
  
  let isDown = false;
  let startX;
  let scrollLeft;

  if (window.innerWidth > 1023) {
    setTimeout(() => {
      if (wrapper.scrollWidth > 0) {
        console.log('scroll');
        wrapper.scrollLeft = wrapper.scrollWidth * 0.1;
      }
    }, 100);
  }

  // scroll
  wrapper.addEventListener('mousedown', (e) => {
    isDown = true;
    wrapper.style.cursor = 'grabbing';
    startX = e.pageX - wrapper.offsetLeft;
    scrollLeft = wrapper.scrollLeft;
  });

  wrapper.addEventListener('mouseleave', () => {
    isDown = false;
    wrapper.style.cursor = 'grab';
  });

  wrapper.addEventListener('mouseup', () => {
    isDown = false;
    wrapper.style.cursor = 'grab';
  });

  wrapper.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - wrapper.offsetLeft;
    const walk = (x - startX) * 2;
    wrapper.scrollLeft = scrollLeft - walk;
  });

  // bullets on scroll
  function updateActiveBullet() {
    const scrollPosition = wrapper.scrollLeft;
    const itemWidth = reviewItems[0].offsetWidth + 25; // 25px is the gap between items
    const activeIndex = Math.round(scrollPosition / itemWidth);
    
    bullets.forEach((bullet, index) => {
      bullet.classList.toggle('active', index === activeIndex);
    });
  }

  wrapper.addEventListener('scroll', updateActiveBullet);

  bullets.forEach((bullet, index) => {
    bullet.addEventListener('click', () => {
      const itemWidth = reviewItems[0].offsetWidth + 25;
      wrapper.scrollTo({
        left: itemWidth * index,
        behavior: 'smooth'
      });
    });
  });
}); 